<template>
  <!-- 스펙234_개선_30: [주문사용자 ID 편집 팝업] -->
  <div class="modal-mask" @click.self="$emit('close')">
    <div class="modal">
      <div class="titlebar">주문사용자ID 편집</div>

      <div class="head">
        <button class="rescan" :disabled="busy" @click="rescan">{{ busy ? '재조회 중…' : '주문사용자ID 재조회' }}</button>
        <span class="spacer"></span>
        <button class="primary" :disabled="busy" @click="save">저장</button>
        <button class="ghost" @click="$emit('close')">닫기</button>
      </div>

      <div class="member">회원 로그인id(이름): {{ loginId }}({{ name }})</div>

      <p v-if="msg" :class="err ? 'err' : 'info'">{{ msg }}</p>
    </div>

    <!-- 스펙234_개선_31: 재조회 결과가 빈값이면 별도 알림 팝업(아이콘 없이) -->
    <div v-if="noticeOpen" class="notice-mask" @click.self="noticeOpen=false">
      <div class="notice-card">
        <button class="notice-x" @click="noticeOpen=false" aria-label="닫기">×</button>
        <div class="notice-title">알림</div>
        <ul class="notice-list">
          <li>네이버에서 회원 가입, 주문 후 [주문사용자ID] 재조회 버튼을 누르시면 주문사용자 ID 값이 표시됩니다.</li>
          <li>회원가입만 하신 경우, 주문사용자 ID 를 직접 입력하신 후, 저장 버튼을 누르시면 됩니다.</li>
          <li>이동하기: <a class="notice-link" href="https://www.naver.com" target="_blank" rel="noopener">https://www.naver.com</a></li>
        </ul>
        <button class="notice-ok" @click="noticeOpen=false">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  name: 'OrderUserIdEditDialog',
  props: { customerId: { type: [Number, String], required: true } },
  data() {
    return { loginId: '', name: '', orderUserId: '', busy: false, msg: '', err: false, noticeOpen: false };
  },
  created() { this.load(); },
  methods: {
    async load() {
      this.msg = '';
      try {
        const res = await api.orderUserIdInfo(this.customerId);
        const d = res.data || {};
        this.loginId = d.loginId || '';
        this.name = d.name || '';
        this.orderUserId = d.orderUserId || '';
      } catch (e) { this.err = true; this.msg = e.message; }
    },
    // 재조회 : [주문사용자ID 조회 배치] 실행 후 주문사용자ID 갱신(db update)
    async rescan() {
      if (this.busy) return;
      this.busy = true; this.msg = ''; this.err = false;
      try {
        const res = await api.orderUserIdRescan(this.customerId);
        this.orderUserId = (res && res.data && res.data.orderUserId) || '';
        // 스펙234_개선_31: 재조회 결과가 빈값이면 별도 안내 팝업 표시
        if (!this.orderUserId) {
          this.msg = '';
          this.noticeOpen = true;
        } else {
          this.msg = (res && res.message) ? res.message : '재조회 완료';
        }
        this.$emit('saved');
      } catch (e) {
        this.err = true;
        this.msg = (e && e.response && e.response.data && e.response.data.message) || e.message || '재조회 실패';
      } finally { this.busy = false; }
    },
    // 저장 : 에디트 내용대로 저장(db update) → 성공 시 팝업 닫기
    async save() {
      if (this.busy) return;
      this.busy = true; this.msg = ''; this.err = false;
      try {
        await api.orderUserIdSave({ customerId: this.customerId, orderUserId: this.orderUserId });
        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        this.err = true;
        this.msg = (e && e.response && e.response.data && e.response.data.message) || e.message || '저장 실패';
      } finally { this.busy = false; }
    }
  }
};
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 70; }
.modal { background: #fff; padding: 18px 20px; border-radius: 8px; width: 520px; max-width: 94vw; }
.head { display: flex; align-items: center; gap: 8px; padding-bottom: 10px; }
.head .spacer { flex: 1; }
.head button { padding: 7px 14px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; font-size: 13px; }
.head .rescan { background: #c0392b; border-color: #c0392b; color: #fff; }
.head .rescan:disabled { opacity: .6; cursor: default; }
.head .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.head .ghost { background: #f5f5f5; color: #33415c; }
.titlebar { font-size: 16px; font-weight: 700; color: #1f2a44; margin-bottom: 12px; }
.member { border-top: 1px solid #eef; padding-top: 12px; margin-bottom: 12px; font-size: 13px; color: #33415c; }
.body { display: flex; align-items: center; gap: 8px; }
.body .cap { font-size: 13px; color: #33415c; font-weight: 600; white-space: nowrap; }
.body .edit { flex: 1; height: 34px; border: 1px solid #cfd6e6; border-radius: 6px; padding: 0 10px; font-size: 14px; }
.body .ghost { height: 34px; padding: 0 12px; border: 1px solid #cfd6e6; border-radius: 6px; background: #fff; color: #33405c; cursor: pointer; font-size: 13px; white-space: nowrap; }
.info { font-size: 13px; color: #2f6fed; margin: 12px 0 0; }
.err { font-size: 13px; color: #d93636; margin: 12px 0 0; }
/* 스펙234_개선_31: 빈값 안내 팝업(아이콘 없음) */
.notice-mask { position: fixed; inset: 0; background: rgba(0,0,0,.4); display: flex; align-items: center; justify-content: center; z-index: 80; }
.notice-card { position: relative; background: #fff; border-radius: 10px; width: 560px; max-width: 94vw; padding: 26px 28px 22px; box-shadow: 0 10px 30px rgba(0,0,0,.25); }
.notice-x { position: absolute; top: 10px; right: 14px; border: none; background: none; font-size: 24px; color: #98a0b0; cursor: pointer; }
.notice-title { font-size: 24px; font-weight: 700; color: #1f2a44; margin-bottom: 18px; }
.notice-list { margin: 0 0 22px; padding-left: 22px; }
.notice-list li { font-size: 17px; color: #33415c; line-height: 1.7; margin-bottom: 10px; }
.notice-link { color: #2f6fed; text-decoration: underline; word-break: break-all; }
.notice-ok { display: block; margin: 0 auto; padding: 10px 30px; background: #2f6fed; color: #fff; border: none; border-radius: 6px; cursor: pointer; font-size: 16px; }
</style>
